/* eslint-disable */
import './Products.css'
import React from 'react'
import axios from 'axios'
import { isEmpty, map, toArray } from 'lodash'
import { db, keygen, storage } from '../../services/firebase'
import { compress, readImage } from '../../services/compressor'
import { connect } from 'react-redux'
import { Grid, Col, Row } from 'react-bootstrap'
import ProductForm from '../../forms/ProductForm.jsx'
import Card from 'components/Card/Card.jsx'
import Gallery from 'components/Gallery/Gallery.jsx'
import Variants from 'components/Variants/Variants.jsx'
import Button from 'elements/CustomButton/CustomButton.jsx'
import SweetAlert from 'react-bootstrap-sweetalert'
import SweetSpinner from 'components/SweetSpinner/SweetSpinner.jsx'
import {
    setModel, setLine, setDescription, setCoverImage, addGalleryImage,
    removeGalleryImage, addVariant, removeVariant, addVariantItem, removeVariantItem,
    resetProduct
} from '../../ducks/Product'

class ProductProfile extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            alert: null
        }

        this.user = props.user
        this.resetForm = props.resetForm
        this.submitForm = props.submitForm
        this.notify = props.notify
    }

    componentDidMount () {
        const { product } = this.props
        const { id } = this.props.match.params

        if (id !== 'new' && product.model === '') {
            this.props.history.push('/products')
        }
    }

    componentWillUnmount () {
        this.props.resetProduct()
    }

    render () {
        const { alert } = this.state
        const { id } = this.props.match.params

        const {
            notify, resetForm, setModel, setLine, setDescription, setCoverImage, addGalleryImage,
            removeGalleryImage, addVariant, removeVariant, addVariantItem, removeVariantItem,
            product, beforeUpdate
        } = this.props

        return (
            <div className='main-content'>
                {alert}
                <Card
                    content={
                        <Grid fluid>
                            <Row>
                                <span className='product_form_title'>
                                    {id === 'new' ? 'Novo produto' : 'Editar produto'}
                                </span>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <ProductForm
                                        initialValues={{
                                            model: product.model,
                                            description: product.description,
                                            productLine: product.productLine,
                                            active: product.active
                                        }}
                                        onSubmit={values => {
                                            id === 'new'
                                                ? this._saveProduct(values)
                                                : this._updateProduct(values)
                                        }}
                                    />
                                </Col>
                            </Row>
                            <div className='product_spacer' />
                            <Gallery
                                product={product}
                                notify={notify}
                                setCoverImage={setCoverImage}
                                addGalleryImage={addGalleryImage}
                                removeGalleryImage={removeGalleryImage}
                            />
                            <div className='product_spacer' />
                            <Variants
                                product={product}
                                notify={notify}
                                resetForm={resetForm}
                                addVariant={addVariant}
                                removeVariant={removeVariant}
                                addVariantItem={addVariantItem}
                                removeVariantItem={removeVariantItem}
                            />
                            <Row>
                                <Col md={6} mdOffset={3} sm={12} xs={12}>
                                    <Col md={6} sm={12} xs={12}>
                                        <Button
                                            style={{ width: '100%', marginTop: 10 }}
                                            bsStyle='danger'
                                            type='button'
                                            onClick={() => this.cancelNewProductAlert()}
                                            wd
                                        >
                                            Cancelar
                                    </Button>
                                    </Col>
                                    <Col md={6} sm={12} xs={12}>
                                        <Button
                                            style={{ width: '100%', marginTop: 10 }}
                                            bsStyle='default'
                                            type='submit'
                                            onClick={() => {
                                                this.props.submitForm('ProductForm')
                                            }}
                                            fill
                                        >
                                            Salvar
                                    </Button>
                                    </Col>
                                </Col>
                            </Row>
                        </Grid>
                    } />
            </div>
        )
    }

    _handleCancel () {
        this.props.resetProduct()
        this.props.resetForm('ProductForm')
        this.props.history.push('/products')
    }

    _saveProduct = async values => {
        this.waitAlert('Adicionando produto, aguarde', true)

        const productKey = keygen()
        const ImagesPromiseStack = []
        const { product, notify } = this.props

        let productToSave = {
            ...values,
            productLine: values.productLine.value,
            productLineName: values.productLine.label,
            active: values.active.value,
            variants: {}
        }

        if (!isEmpty(product.variants)) {
            map(product.variants, variant => {
                let variantData = {
                    id: variant.id,
                    name: variant.name || null,
                    description: variant.description || null,
                    items: {}
                }

                if (variant.items && !isEmpty(variant.items)) {
                    map(variant.items, item => {
                        variantData.items[item.id] = {
                            id: item.id,
                            name: item.name,
                            description: item.description,
                            accessories: {},
                            composition: {},
                            fabricLines: {}
                        }
                        //Flattening item internal data, disassembling Redux array.
                        if (item.accessories && item.accessories.length) {
                            map(item.accessories, accessory => variantData.items[item.id].accessories[accessory.id] = { ...accessory })
                        }

                        if (item.composition && item.composition.length) {
                            map(item.composition, comp => variantData.items[item.id].composition[comp.id] = { ...comp })
                        }

                        if (item.fabricLines && item.fabricLines.length) {
                            map(item.fabricLines, line => variantData.items[item.id].fabricLines[line.fx] = { ...line })
                        }

                    })
                }

                productToSave.variants[variant.id] = variantData
            })
        }

        if (product.coverImage) {
            const uploadedCover = await this._handleImage(product.coverImage, productKey, 'products')
            productToSave.coverImageURL = uploadedCover.downloadURL
            productToSave.coverImageName = uploadedCover.metadata.name
        }

        if (!isEmpty(product.gallery)) {
            map(product.gallery, async galleryImage => {
                let uploadedGalleryImage = await this._handleImage(galleryImage.image, galleryImage.id, 'products')

                ImagesPromiseStack.push(
                    db
                        .collection('products')
                        .doc(productKey)
                        .collection('gallery')
                        .doc(galleryImage.id)
                        .set({
                            downloadURL: uploadedGalleryImage.downloadURL,
                            name: uploadedGalleryImage.metadata.name
                        })
                )
            })
        }

        db.collection('products').doc(productKey).set(productToSave)
            .then(_ => {
                Promise.all(ImagesPromiseStack)
                    .then(_ => {
                        let productToAlgolia = { ...productToSave }
                        productToAlgolia.description && delete productToAlgolia.description
                        productToAlgolia.variants && delete productToAlgolia.variants

                        axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaAdd_HTTPS', {
                            id: productKey, data: productToAlgolia
                        })
                            .then(() => {
                                notify('Produto adicionado.', 'success')
                                this.hideAlert()
                                this.props.resetProduct()
                                this.props.history.push('/products')
                            })
                            .catch(e => {
                                console.log(e)
                                notify('Erro ao sincronizar os dados.', 'error')
                            })
                    })
                    .catch(e => {
                        console.log(e)
                        notify('Erro ao salvar as imagens da galeria.', 'error')
                    })
            })
            .catch(e => {
                console.log(e)
                notify('Erro ao salvar produto.', 'error')
            })
    }

    _updateProduct = async values => {
        const { id } = this.props.match.params
        const { product, notify, beforeUpdate } = this.props

        this.waitAlert('Atualizando produto, aguarde', true)

        let productToSave = {
            ...values,
            productLine: typeof (values.productLine) === 'object' ? values.productLine.value : values.productLine,
            active: typeof (values.active) === 'object'
                ? values.active.value
                : values.active,
            variants: {}
        }

        typeof (values.productLine) === 'object' && (productToSave.productLineName = values.productLine.label)


        if (!isEmpty(product.variants)) {
            map(product.variants, variant => {
                let variantData = {
                    id: variant.id,
                    name: variant.name || null,
                    description: variant.description || null,
                    items: {}
                }

                if (variant.items && !isEmpty(variant.items)) {
                    map(variant.items, item => {
                        variantData.items[item.id] = {
                            id: item.id,
                            name: item.name,
                            description: item.description,
                            accessories: {},
                            composition: {},
                            fabricLines: {}
                        }
                        //Flattening item internal data, disassembling Redux array.
                        if (item.accessories && item.accessories.length) {
                            map(item.accessories, accessory => variantData.items[item.id].accessories[accessory.id] = { ...accessory })
                        }

                        if (item.composition && item.composition.length) {
                            map(item.composition, comp => variantData.items[item.id].composition[comp.id] = { ...comp })
                        }

                        if (item.fabricLines && item.fabricLines.length) {
                            map(item.fabricLines, line => variantData.items[item.id].fabricLines[line.fx] = { ...line })
                        }

                    })
                }

                productToSave.variants[variant.id] = variantData
            })
        }

        if (product.coverImage !== beforeUpdate.coverImage) { //remove old image
            storage.ref().child(`products/${beforeUpdate.coverImageName}`).getDownloadURL()
                .then(async url => {
                    await storage.ref().child(`products/${beforeUpdate.coverImageName}`).delete()
                    if (product.coverImage) {
                        const updatedCover = await this._handleImage(product.coverImage, id, 'products')
                        productToSave.coverImageURL = updatedCover.downloadURL
                        productToSave.coverImageName = updatedCover.metadata.name
                    }
                    this._updateUsingAxios(id, productToSave)
                })
                .catch(async e => {
                    if (product.coverImage) {
                        const updatedCover = await this._handleImage(product.coverImage, id, 'products')
                        productToSave.coverImageURL = updatedCover.downloadURL
                        productToSave.coverImageName = updatedCover.metadata.name
                    }

                    this._updateUsingAxios(id, productToSave)
                })
        } else {
            this._updateUsingAxios(id, productToSave)
        }
    }

    _updateUsingAxios = (id, data) => {
        const { notify } = this.props
        console.log('Updating in Firestore...')
        db.collection('products').doc(id).update(data)
            .then(() => {
                console.log('Updated in Firestore. Updating Algolia...')
                let productToAlgolia = { ...data }
                productToAlgolia.description && delete productToAlgolia.description
                productToAlgolia.variants && delete productToAlgolia.variants
                axios.post('https://us-central1-enele-e47f5.cloudfunctions.net/syncAlgoliaUpdate_HTTPS', {
                    id, data: productToAlgolia
                })
                    .then(() => {
                        this._updateGallery()
                            .then(() => {

                                notify('Produto atualizado.', 'success')
                                this.hideAlert()
                                this.props.resetProduct()
                                this.props.history.push('/products')
                            })
                            .catch(e => {
                                console.log(e)
                                notify('Erro ao atualizar a galeria.', 'error')
                            })
                    })
                    .catch(e => {
                        console.log(e)
                        this.hideAlert()
                        notify('Erro ao sincronizar os dados.', 'error')
                    })
            })
            .catch(e => {
                console.log(e)
                notify('Erro ao salvar produto.', 'error')
            })
    }

    _updateGallery () {
        const PromiseStack = []
        const { id } = this.props.match.params
        const { beforeUpdate, product, notify } = this.props

        return new Promise((resolve, reject) => {
            if (!isEmpty(beforeUpdate.gallery) && isEmpty(product.gallery)) {
                console.log('Remover todas as imagens da galeria')

                map(beforeUpdate.gallery, imageToRemove => {

                    PromiseStack.push(
                        db.collection('products').doc(id).collection('gallery').doc(imageToRemove.id).delete()
                            .catch(e => console.log('Error removing image from db')),
                        storage.ref().child(`products/${imageToRemove.imageName}`).delete()
                            .catch(e => console.log('Error removing image from storage'))
                    )
                })

                Promise.all(PromiseStack)
                    .then(() => notify('Galeria removida.', 'success'))
                    .catch(e => notify('Erro ao modificar a galeria de imagens.', 'error'))

            } else if (isEmpty(beforeUpdate.gallery) && !isEmpty(product.gallery)) {
                console.log('Adicionar todas as imagens da galeria')
                map(product.gallery, async imageToAdd => {
                    let newImage = await this._handleImage(imageToAdd.image, imageToAdd.id, 'products')

                    PromiseStack.push(
                        db.collection('products').doc(id).collection('gallery').doc(imageToAdd.id)
                            .set({
                                downloadURL: newImage.downloadURL,
                                name: newImage.metadata.name
                            })
                            .catch(e => console.log('Error adding image to db'))
                    )
                })

                return Promise.all(PromiseStack)
                    .then(() => notify('Imagens adicionadas a galeria.', 'success'))
                    .catch(e => notify('Erro ao adicionar imagens a galeria.', 'error'))

            } else {
                const arrayBefore = toArray(beforeUpdate.gallery)
                const arrayProduct = toArray(product.gallery)

                //Adds new items to the gallery
                map(arrayProduct, async currentGalleryItem => {
                    if (!arrayBefore.find(x => x.id === currentGalleryItem.id)) {
                        let newImage = await this._handleImage(currentGalleryItem.image, currentGalleryItem.id, 'products')
                        PromiseStack.push(
                            db.collection('products').doc(id).collection('gallery').doc(currentGalleryItem.id)
                                .set({
                                    downloadURL: newImage.downloadURL,
                                    name: newImage.metadata.name
                                })
                                .catch(e => console.log('Error adding image to db'))
                        )
                    }
                })

                //Remove missing items in current gallery
                map(arrayBefore, async oldGalleryItem => {
                    if (!arrayProduct.find(x => x.id === oldGalleryItem.id)) {
                        PromiseStack.push(
                            db.collection('products').doc(id).collection('gallery').doc(oldGalleryItem.id).delete()
                                .catch(e => console.log('Error removing image from db')),
                            storage.ref().child(`products/${oldGalleryItem.imageName}`).delete()
                                .catch(e => console.log('Error removing image from storage'))
                        )
                    }
                })

                //Resolve the Promise stack
                return Promise.all(PromiseStack)
                    .then(() => resolve('Galeria atualizada.'))
                    .catch(e => reject('Erro ao atualizar a galeria.'))
            }
        })
    }

    async _handleImage (image, name, pathToUpload) {
        const receivedImage = await image
        const compressedImage = await compress(receivedImage.src)
        const extension = this._handleExtension(compressedImage.type)

        if (extension) {
            const uploadedImage = await storage.ref().child(`${pathToUpload}/${name}.${extension}`).put(compressedImage)
            return uploadedImage
        } else {
            this.props.notify('Erro ao comprimir imagem.', 'error')
        }
    }

    _handleExtension (mimeType) {
        let ext = mimeType.split('/')
        switch (ext[1]) {
            case 'jpeg':
            case 'jpg':
                return 'jpg'
            case 'png':
                return 'png'
            default:
                return null
        }
    }

    //SweetAlerts
    hideAlert = () => this.setState({ alert: null })

    waitAlert = (title, showSpinner) => {
        this.setState({
            alert: (
                <SweetAlert
                    style={{ display: 'block' }}
                    title={title}
                    onConfirm={() => null}
                    showConfirm={false}
                >
                    {showSpinner ? (<SweetSpinner />) : null}
                </SweetAlert>
            )
        })
    }

    cancelNewProductAlert = partner => {
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    style={{ display: "block" }}
                    title="Tem certeza?"
                    onConfirm={() => this._handleCancel()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="default"
                    cancelBtnBsStyle="warning"
                    confirmBtnText="Continuar"
                    cancelBtnText="Cancelar"
                    showCancel
                >
                    Todas as alterações serão perdidas.
                </SweetAlert>
            )
        });
    }
}

const mapStateToProps = state => ({ product: state.product.product, beforeUpdate: state.product.beforeUpdate })

export default connect(mapStateToProps, {
    setModel, setLine, setDescription, setCoverImage, addGalleryImage,
    removeGalleryImage, addVariant, removeVariant, addVariantItem, removeVariantItem,
    resetProduct
})(ProductProfile)


// WEBPACK FOOTER //
// ./src/views/Products/ProductProfile.jsx